// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

const isProd = process.env.NODE_ENV === "production";

// 这里就是全局唯一的 i18n 实例
i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "zh"],
    fallbackLng: "zh",
    lng:"zh",
    cleanCode: true,

    // 你规划的 11 个命名空间，写上就行
    ns: [
      "common",
      "auth",
      "signup",
      "verify",
      "dashboard",
      "payment",
      "actions",
      "profile",
      "coupons",
      "points",
      "settings",
      "notifications",
    ],
    defaultNS: "common",
    fallbackNS: ["common"],

    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      lookupQuerystring: "lang",   // 👈 新增：告诉 i18next 用 lang 做参数
      caches: ["localStorage"],
    },

    backend: {
      // 会去 /public/locales/<lng>/<ns>.json 拿
      loadPath: "/locales/{{lng}}/{{ns}}.json?v=20251103",
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },

    returnEmptyString: false,
    debug: !isProd,
  });

// ✅ 强制预加载全部命名空间，防止弹窗时翻译未加载
if (typeof window !== "undefined") {
  window.i18n = i18n;
  i18n.loadNamespaces([
    "common",
    "auth",
    "signup",
    "verify",
    "dashboard",
    "payment",
    "actions",
    "profile",
    "coupons",
    "points",
    "settings",
    "notifications"
  ]);
}

export default i18n;
